import dlv from 'dlv';

const prog = (func) => {
  return Object.keys(func.run)[0];
};

const text = (func) =>{
  const p = func.run[prog(func)];

  if (typeof p === 'string') {
    return p;
  }

  return p.text;
};

const connectionId = (func, d) =>{
  const p = func.run[prog(func)];

  return p.connection_id || d;
};

const subject = (func, d) =>{
  const p = func.run[prog(func)];

  return p.subject || d;
};

const payload = (func, d) =>{
  const p = func.run[prog(func)];
  return p.payload || d;
};

const save = (func) =>{
  const p = func.run[prog(func)];

  return p.save;
};


const query = (func) => {
  return dlv(func, 'run.EMAIL.query.records')
      || dlv(func, 'run.DONE_EMAIL.query.records')
      || dlv(func, 'run.TODO_EMAIL.query.records');
};

const interval = (func) => {
  return dlv(func, 'run.EMAIL.query.interval') ||
         dlv(func, 'run.DONE_EMAIL.query.interval') ||
         dlv(func, 'run.TODO_EMAIL.query.interval');
}

const path = (func, d) => {
  const q = query(func);

  if (!q) {
    return d
  }

  const p = q.AND.find(c => c.entity === 'PATH') || {};

  return p.term || d;
};

const tags = (func, d) => {
  const q = query(func);

  if (!q) {
    return d;
  }

  const t = q.AND.find(c => c.entity === 'TAG') || {};

  return (t.term || d);
};

const type = (func, d) => {
  const q = query(func);

  if (!q) {
    return d;
  }

  const t = q.AND.find(c => c.entity === 'TODO') || {};

  return t.term || d;
};


export default {
  prog, text, subject, save, query, interval, path, tags, type, connectionId, payload

};
